import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Button from '../ui/Button';

const WALNUT = '#8B4513';
const STONE = '#8C8275';
const PAPER = '#FDFBF8';

export default function MonthNavigation({ currentDate, onPrevious, onNext, onToday, onDateChange }) {
  const currentMonth = new Date(currentDate).getMonth();
  const currentYear = new Date(currentDate).getFullYear();

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  // Generate years from 2020 to current year + 10
  const startYear = 2020;
  const endYear = new Date().getFullYear() + 10;
  const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);

  function handleMonthChange(e) {
    const newMonth = parseInt(e.target.value);
    const newDate = new Date(currentYear, newMonth, 1);
    onDateChange(newDate);
  }

  function handleYearChange(e) {
    const newYear = parseInt(e.target.value);
    const newDate = new Date(newYear, currentMonth, 1);
    onDateChange(newDate);
  }

  const selectStyle = {
    padding: '8px 12px',
    fontSize: '14px',
    fontWeight: '600',
    color: WALNUT,
    background: PAPER,
    border: `1px solid ${STONE}44`,
    borderRadius: '8px',
    cursor: 'pointer',
    outline: 'none'
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    }}>
      <Button
        variant="secondary"
        size="small"
        onClick={onPrevious}
        style={{ padding: '8px 12px', display: 'flex', alignItems: 'center', gap: '4px' }}
      >
        <ChevronLeft size={14} strokeWidth={2} /> Prev
      </Button>

      {/* Month Dropdown */}
      <select value={currentMonth} onChange={handleMonthChange} style={selectStyle}>
        {months.map((month, index) => (
          <option key={index} value={index}>
            {month}
          </option>
        ))}
      </select>

      {/* Year Dropdown */}
      <select value={currentYear} onChange={handleYearChange} style={selectStyle}>
        {years.map(year => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>

      <Button
        variant="secondary"
        size="small"
        onClick={onNext}
        style={{ padding: '8px 12px', display: 'flex', alignItems: 'center', gap: '4px' }}
      >
        Next <ChevronRight size={14} strokeWidth={2} />
      </Button>

      <Button
        variant="primary"
        size="small"
        onClick={onToday}
      >
        Today
      </Button>
    </div>
  );
}
